jQuery(document).ready(function ($) {
  $("#portfolio_category").on("change", function () {
    if ($(this).val()) {
      window.location.href = "/portfolio/category/" + $(this).val() + "/";
    } else {
      window.location.href = "/portfolio/";
    }
  });
});
